import { Alerts, Brand, Neutrals, Theme } from './colors';

export const Buttons = {
  primary: {
    ButtonPrimaryBackgroundDefault: Theme.main.ThemeWater,
    ButtonPrimaryBackgroundHover: Brand.water.Water800,
    ButtonPrimaryBackgroundPressed: Brand.water.Water900,
    ButtonPrimaryBackgroundDisable: Neutrals.neutralGreys.GreyNatural100,
    ButtonPrimaryBackgroundDrag: Neutrals.main.White,
    ButtonPrimaryTextDefault: Neutrals.main.White,
    ButtonPrimaryTextDisable: Neutrals.neutralGreys.GreyNatural500,
    ButtonPrimaryTextDrag: Theme.main.ThemeWater,
    ButtonPrimaryStrokeDrag: Theme.main.ThemeWater,
    ButtonPrimaryIconDefault: Neutrals.main.White,
    ButtonPrimaryIconDisable: Neutrals.neutralGreys.GreyNatural500,
  },
  secondary: {
    ButtonSecondaryBackgroundDefault: Neutrals.main.White,
    ButtonSecondaryBackgroundHover: Neutrals.neutralGreys.GreyNatural050,
    ButtonSecondaryBackgroundPressed: Neutrals.neutralGreys.GreyNatural150,
    ButtonSecondaryTextDefault: Theme.main.ThemeWater,
    ButtonSecondaryTextDisable: Neutrals.neutralGreys.GreyNatural300,
    ButtonSecondaryStrokeDefault: Theme.main.ThemeWater,
    ButtonSecondaryStrokeDisable: Neutrals.neutralGreys.GreyNatural050,
    ButtonSecondaryIconDefault: Theme.main.ThemeWater,
    ButtonSecondaryIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
  tertiary: {
    ButtonTertiaryBackgroundDefault: Neutrals.main.White,
    ButtonTertiaryBackgroundHover: Neutrals.coldGreys.GreyCold050,
    ButtonTertiaryBackgroundPressed: Brand.water.Water050,
    ButtonTertiaryTextDefault: Theme.main.ThemeWater,
    ButtonTertiaryTextDisable: Neutrals.neutralGreys.GreyNatural300,
    ButtonTertiaryStrokeDefault: Neutrals.coldGreys.GreyCold200,
    ButtonTertiaryStrokeDisable: Neutrals.neutralGreys.GreyNatural050,
    ButtonTertiaryIconDefault: Theme.main.ThemeWater,
    ButtonTertiaryIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
  quaternaryOnLight: {
    ButtonQuaternaryOnLightBgDefault: Neutrals.coldGreys.GreyCold050,
    ButtonQuaternaryOnLightBgHover: Neutrals.coldGreys.GreyCold100,
    ButtonQuaternaryOnLightBgPressed: Neutrals.coldGreys.GreyCold150,
    ButtonQuaternaryOnLightBgDisable: Neutrals.neutralGreys.GreyNatural150,
    ButtonQuaternaryOnLightTextDefault: Theme.main.ThemeWater,
    ButtonQuaternaryOnLightTextDisable: Neutrals.neutralGreys.GreyNatural300,
    ButtonQuaternaryOnLightStrokeDrag: Theme.main.ThemeWater,
    ButtonQuaternaryOnLightIconDefault: Theme.main.ThemeWater,
    ButtonQuaternaryOnLightIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
  quaternaryOnDark: {
    ButtonQuaternaryOnDarkBgDefault: Neutrals.main.White,
    ButtonQuaternaryOnDarkBgHover: Neutrals.coldGreys.GreyCold100,
    ButtonQuaternaryOnDarkBgPressed: Neutrals.coldGreys.GreyCold150,
    ButtonQuaternaryOnDarkBgDisable: Neutrals.neutralGreys.GreyNatural100,
    ButtonQuaternaryOnDarkTextDefault: Theme.main.ThemeWater,
    ButtonQuaternaryOnDarkTextDisable: Neutrals.neutralGreys.GreyNatural500,
    ButtonQuaternaryOnDarkStokeDrag: Theme.main.ThemeWater,
    ButtonQuaternaryOnDarkIconDefault: Theme.main.ThemeWater,
    ButtonQuaternaryOnDarkIconDisable: Neutrals.neutralGreys.GreyNatural500,
  },
  ghost: {
    ButtonGhostBackgroundPressed: Brand.water.Water050,
    ButtonGhostTextDefault: Theme.main.ThemeWater,
    ButtonGhostTextHover: Brand.water.Water800,
    ButtonGhostTextDisable: Neutrals.neutralGreys.GreyNatural300,
    ButtonGhostStrokeDrag: Theme.main.ThemeWater,
    ButtonGhostIconDefault: Theme.main.ThemeWater,
    ButtonGhostIconHover: Brand.water.Water800,
    ButtonGhostIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
  destructive: {
    ButtonDestructiveBackgroundDefault: Neutrals.main.White,
    ButtonDestructiveBackgroundPressed: Alerts.Red100,
    ButtonDestructiveTextDefault: Alerts.Red500,
    ButtonDestructiveTextHover: Alerts.Red800,
    ButtonDestructiveTextDisable: Neutrals.neutralGreys.GreyNatural300,
    ButtonDestructiveStrokeDrag: Alerts.Red500,
    ButtonDestructiveIconDefault: Alerts.Red500,
    ButtonDestructiveIconHover: Alerts.Red800,
    ButtonDestructiveIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
  ghostBlack: {
    ButtonGhostBlackBackgroundHover: Neutrals.coldGreys.GreyCold050,
    ButtonGhostBlackBackgroundPressed: Brand.water.Water050,
    ButtonGhostBlackIconDefault: Neutrals.neutralGreys.GreyNatural900,
    ButtonGhostBlackIconDisable: Neutrals.neutralGreys.GreyNatural300,
  },
};
